import React from 'react';
import Icon from 'components/Utils/NewIcon';
import './style.scss';
import { ToastOptions } from '.';

type Props = {
  onClose: () => void;
  visible: boolean;
  options: ToastOptions;
};

export default ({ onClose, visible, options }: Props) => {
  let cs = 'toast ' + (visible ? 'is-visible' : 'not-visible');
  if (options.className) {
    cs += ` ${options.className}`;
  }

  let icon: string;

  if (options.type === 'success') {
    icon = 'circle-check';
  } else if (options.type === 'error') {
    icon = 'circle-xmark';
  } else {
    icon = 'circle-info';
  }

  return (
    <div className={cs} data-type={options.type}>
      <div className="wrapper-box">
        <div className="left">
          <Icon src={icon} width="30px" />
        </div>
        <div className="right">
          <span>{options.message}</span>
          <Icon className="white" src="xmark" width="20px" height="20px" onClick={onClose} />
        </div>
      </div>
    </div>
  );
};
